module.exports = __webpack_public_path__ + "static/media/wind.2d8c51c5.svg";